
<div>
  <section class="enkai__shops" v-if="isReady">
    <area-shops
      :prefecture="prefectureNameEn"
      :area="area"
      :area-detail="areaDetail"
      :station="station"
      :price_to="priceTo"
      :people_from="peopleFrom"
      :shop-type="shopType"
      @shopsCount="updateShopCount"
      @shops="updateShops"
    />
  </section>
  <section class="enkai__searchLinks">
    <search-location-links
      :prefecture-name="prefectureName"
      :prefecture-name-en="prefectureNameEn"
      :area="area"
      :area-detail="areaDetail"
      :station="station"
    />
  </section>
  <section class="enkai__faq" v-if="isPrefecturePage && shopsCount > 0">
    <area-faq
      :prefecture-name="prefectureName"
      :shopsCount="shopsCount"
      :shops="shops"
      :areas-in-prefecture="areasInPrefecture"
    />
  </section>
</div>
